import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type Fleet } from '../domain/fleet';

const initialState: Fleet = {
    assignedGroups: [],
    createdAt: '',
    createdBy: '',
    name: '',
    owner: '',
    packets: [],
    prefix: '',
    updatedAt: '',
    updatedBy: '',
    vehicles: [],
};

const fleetSlice = createSlice({
    initialState,
    name: 'fleet',
    reducers: {
        clearFleet: () =>
            initialState,
        setFleet: (state, action: PayloadAction<Fleet>) => {
            const newState = action.payload;
            return newState;
        }
        ,
    },
});

// Export the action creators and reducer
export const { setFleet, clearFleet } = fleetSlice.actions;
export default fleetSlice.reducer;
